import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShimmerPostList } from "react-shimmer-effects";
import { useDispatch, useSelector } from "react-redux";
import { GetAllServiceProduct } from "../../../../../store/actions/new/storeAction";
import NoContentFound from "../../../../default/not-found/notFound";
import PaymentMethodModal from "../../../../subscription/popup/paymentMethodPopup";

const ServiceData = () => {
    const [isMonthly, setIsMonthly] = useState(true);
    const [productId, setProductId] = useState('');
    const [ProductData, setProductData] = useState('');

    //function to show popup
    const [openPopup, setPopup] = useState(false);
    const handlePaymentPopup = (productId, item) => {
        console.log(item);
        setPopup(true);
        setProductId(productId);
        setProductData(item);
    }
    // store data
    const { products, isLoading } = useSelector((store) => store.storeData);
    const { data, category } = products;
    const dispatch = useDispatch();
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path ? 'active-section' : '';
    };

    useEffect(() => {
        if (!data || data.length === 0) {
            dispatch(GetAllServiceProduct());
        }
    }, [dispatch, data])

    return (
        <div>
            <div className="service-navigation">
                <div className="service-navigation-item">
                    <Link className={isActive('/user/store/subscriptions')} to="/user/store/subscriptions">Subscriptions</Link>
                </div>
                <div className="service-navigation-item">
                    <Link className={isActive('/user/store/services')} to="/user/store/services">Services</Link>
                </div>
            </div>
            <div className="card-container card-package-area store-data-wrapper">
                {isLoading && <ShimmerPostList postStyle="STYLE_FOUR" col={3} row={1} gap={30} />}
                {!isLoading && (
                    <>
                        <div className="package-wrapper">
                            {data && data.length > 0 ? data.map((item) => {
                                return (
                                    <div className="pricing-table" key={item.id}>
                                        <div className="pricing-plan">
                                            <h4 className="pricing-title"><span className={item.title === 'Advance' ? "color-primary" : "color-secondary"}>{item.title}</span></h4>
                                            <div className={item.title === 'Advance' ? "pricing-wrapper bg-br-primary text-white py-2" : "pricing-wrapper bg-br-secondary text-white py-2"}>
                                                <sup>$</sup>
                                                <span className="price">{item.price}</span>

                                                {item.renewalIntervalName === "Year" ? "<sub>/year</sub>" : item.renewalIntervalName === "Month" ? "<sub>/month</sub>" : ""}

                                            </div>
                                        </div>
                                        <ul className="features">
                                            <p>{item.description}</p>
                                        </ul>
                                        <Link onClick={() => { handlePaymentPopup(item.id, item) }} className={item.title === 'Advance' ? "btn bg-br-primary" : "btn btn-lightgreen"}>Get Started</Link>
                                    </div>
                                )
                            }) : null}
                        </div>
                        {(!data || data.length === 0) && !isLoading && (
                            <div className="no-packages">
                                <NoContentFound title="No Product found!" />
                            </div>
                        )}
                    </>
                )}
            </div>
            <PaymentMethodModal openModal={openPopup} setOpen={setPopup} productId={productId} productPpData={ProductData} />
        </div>
    );
}
export default ServiceData;